import React, { Component } from 'react'
import Predefine_Colar_Soccer from '../components/Predefine_Colar_Soccer/Predefine_Colar_Soccer'

export class Predefine_Colar_SoccerPage extends Component {
  render() {
    return (
     <Predefine_Colar_Soccer/>
    )
  }
}

export default Predefine_Colar_SoccerPage